module.exports = __webpack_public_path__ + "img/folder-medical.856438de.svg";